import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../css/WhyChooseUs.css";
const reasons = [
    {
        number: "01",
        title: "Bắt trọn cảm xúc",
        description:
            "Lưu giữ những nụ cười, ánh mắt và khoảnh khắc tự nhiên trong ngày trọng đại.",
    },
    {
        number: "02",
        title: "Kể chuyện bằng hình ảnh",
        description:
            "Mỗi bộ ảnh và thước phim là một câu chuyện riêng, mang dấu ấn của từng cặp đôi.",
    },
    {
        number: "03",
        title: "Lưu giữ kỷ niệm dài lâu",
        description:
            "Cùng bạn lưu lại những khoảnh khắc ý nghĩa để có thể nhìn lại qua nhiều năm.",
    },
];

export default function WhyChooseUs() {
    return (
        <section className="why-minmedia">
            <Container>
                <div className="why-heading">
                    <span className="why-eyebrow">MINMIN WEDDING - PHÓNG SỰ CƯỚI</span>
                    <h2>Hơn cả một khung hình</h2>
                    <p>
                        Chúng tôi muốn lưu giữ không chỉ những gì bạn nhìn thấy,
                        mà cả những cảm xúc làm nên ngày đặc biệt.
                    </p>
                </div>

                <Row className="g-4">
                    {reasons.map((item) => (
                        <Col md={4} key={item.number}>
                            <div className="why-card">
                                <span className="why-number">
                                    {item.number}
                                </span>
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
}